import { InjectionToken } from '@angular/core';

export const STATIC_BASE_PATH = new InjectionToken<string>('staticBasePath');
